// extracted by mini-css-extract-plugin
export var closeButton = "_qm-2";
export var closeButtonIcon = "_qm-3";
export var lightboxContent = "_qm-1";
export var lightboxOverlay = "_qm-0";